import React from 'react';
import { Popover } from '@opendoor/bricks/complex';
import { Flex, Text, Heading, Button } from '@opendoor/bricks/core';
import {
  HAS_SEEN_UNENROLLMENT_MODAL,
  LWC_BUTTON_STYLES,
  LWC_MODAL_STYLES,
} from 'sellDirect/routes/lwc/helpers/constants';
import { useQualificationContext } from 'shared/helpers/QualificationContext';
import { useOfferContext } from 'sellDirect/OfferContext';

/**
 * Shown to the user when they unenroll from LWC and are transitioned to the Sell Direct experience
 * component-test-check-ignore storybook-check-ignore
 */
export const UnenrollmentModal: React.FC = () => {
  const { isEligibleForLwc, isInLwcPilot } = useQualificationContext();
  const { offer } = useOfferContext();

  const hasSeenUnenrollmentModal =
    window.localStorage.getItem(HAS_SEEN_UNENROLLMENT_MODAL) === 'true';

  /* Logic for whether it should be open is as follows
   * 1. User is eligible for LWC
   * 2. User is NOT in LWC pilot - Indicating that they were unenrolled from LWC
   * 3. Offer is NOT expired - If an offer is already expired and they go to their dashboard we shouldn't show the modal since they'll see the repeat experience modal
   * 4. User has seen the unenrollment modal
   */
  const shouldSeeUnenrollmentModal =
    (isEligibleForLwc && !isInLwcPilot && !offer?.isExpired && !hasSeenUnenrollmentModal) ?? false;

  const [isOpen, setIsOpen] = React.useState(shouldSeeUnenrollmentModal);

  const handleClose = () => {
    window.localStorage.setItem(HAS_SEEN_UNENROLLMENT_MODAL, 'true');
    setIsOpen(false);
  };

  return (
    <Popover
      aria-label="list-with-certainty-introduction-modal"
      analyticsName="lwc-unenrollment-modal"
      isOpen={isOpen}
      onRequestClose={handleClose}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        width={[null, null, LWC_MODAL_STYLES.desktopMaxWidth]}
        mb={[null, null, 8]}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          maxWidth={LWC_MODAL_STYLES.desktopContentMaxWidth}
          mb={5}
        >
          <Heading size="h2" mb="5" as="h2">
            Sell your way
          </Heading>
          <Text fontSize="s1" lineHeight="s1" mb="8">
            We’re updating this page to match your preferred selling plan.
          </Text>
          <Button
            analyticsName="lwc-unenrollment-modal-button"
            aria-label="View updated selling plan"
            onClick={handleClose}
            minHeight={[
              LWC_BUTTON_STYLES.mobileMinHeight,
              null,
              LWC_BUTTON_STYLES.desktopMinHeight,
            ]}
          >
            View selling plan
          </Button>
        </Flex>
      </Flex>
    </Popover>
  );
};
